import { ATCPageOptionsRowSectionSlot } from '../typings/OptionsRowSection';

export function mapSlotsToProducts(slots: ATCPageOptionsRowSectionSlot[]): string {
  const products = slots.flatMap(slot => slot.slotProducts?.[0]?.id);

  return products.filter(Number).join(',');
}
